export default __webpack_public_path__ + "static/media/bag.124f7ea0.svg";